/**
 * @generated SignedSource<<c34deb6af79a57e70a4de8de6569d530>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransferAppDestination_transferRequestDestination$data = {
  readonly __typename: "Organization";
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TransferAppDestination_transferRequestDestination";
} | {
  readonly __typename: "UserDestination";
  readonly email: string;
  readonly " $fragmentType": "TransferAppDestination_transferRequestDestination";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TransferAppDestination_transferRequestDestination";
};
export type TransferAppDestination_transferRequestDestination$key = {
  readonly " $data"?: TransferAppDestination_transferRequestDestination$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransferAppDestination_transferRequestDestination">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TransferAppDestination_transferRequestDestination",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        (v0/*:: as any*/)
      ],
      "type": "UserDestination",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*:: as any*/)
      ],
      "type": "Organization",
      "abstractKey": null
    }
  ],
  "type": "AppDestination",
  "abstractKey": "__isAppDestination"
};
})();

(node as any).hash = "32a223da520699e43e6adbe6e5790e51";

export default node;
